// src/pages/system/ClientLogin.js

import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authService } from '../../services/api';
import '../../styles/system/ClientLogin.css';

const ClientLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await authService.loginCliente({ email, password });
      localStorage.setItem('token', data.access_token);
      localStorage.setItem('user', JSON.stringify(data.user));

      // Define o tempo de expiração de 30 minutos para API de astrologia
      const expiration = new Date().getTime() + 30 * 60 * 1000;
      localStorage.setItem('api_access_expires_at', expiration);

      navigate('/client/chat'); // Página pós-login do cliente
    } catch (err) {
      setError(err.message || 'Erro na autenticação');
    } finally {
      setLoading(false);
    }
  };

  const handleOAuth = (provider) => {
    window.location.href = `${process.env.REACT_APP_API_URL}/auth/${provider}`;
  };

  return (
    <div className="client-login-container">
      <div className="client-login-box">
        <img src="/images/site/logo192.svg" alt="Logo" className="client-login-logo" />
        <h2>Acesso ao Portal da Liv_IAm</h2>

        {error && <div className="client-login-error">{error}</div>}

        <form onSubmit={handleSubmit} className="client-login-form">
          <input
            type="email"
            name="email"
            placeholder="Seu e-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Sua senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit" disabled={loading} className="client-login-button">
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        <div className="client-login-links">
          <Link to="/recuperar-senha">Esqueci minha senha</Link>
          <Link to="/client/register">Criar conta</Link>
          <Link to="/">Página Inicial</Link>
        </div>

        <div className="client-login-social">
          <p>ou entre com</p>
          <button onClick={() => handleOAuth('google')} className="google-btn">Google</button>
          <button onClick={() => handleOAuth('facebook')} className="facebook-btn">Facebook</button>
          <button onClick={() => handleOAuth('instagram')} className="instagram-btn">Instagram</button>
        </div>
      </div>
    </div>
  );
};

export default ClientLogin;
